module.exports = __webpack_public_path__ + "img/SethRowland.1dd901ca.jpg";